import e, { createElement as t, useCallback as n, useEffect as r, useImperativeHandle as i, useLayoutEffect as a, useRef as o, useState as s } from "react";
import { Fragment as c, jsx as l, jsxs as u } from "react/jsx-runtime";
//#region src/core/iframeContainer/index.tsx
var d = class {
	iframe;
	iframeStatus;
	readyQueue = [];
	errorQueue = [];
	loadError;
	containerDom;
	constructor() {
		this.iframe = this.createIframe(), this.iframeStatus = "INIT";
	}
	createIframe() {
		let e = document.createElement("iframe");
		return this.iframe = e, e.style.cssText = "width: 100%; height: 100%; border: none; padding: 0; margin: 0; box-sizing: border-box; overflow: hidden", e;
	}
	getHTMLTemplate() {
		return "\n    <!doctype html>\n    <html class=\"chameleon-design-mode\">\n      <head>\n        <meta charset=\"utf-8\"/>\n        <style>\n          html,body,#app {\n            margin: 0;\n            padding: 0;\n            box-sizing: border-box;\n            width: 100%;\n            height: 100%;\n          }\n          * {\n            margin: 0;\n            padding: 0;\n            box-sizing: border-box;\n          }\n          img,audio,video {\n            user-select: none;\n            -webkit-user-drag: none;\n          }\n        </style>\n      </head>\n      <body>\n        <div id=\"app\"><div>\n      </body>\n    </html>    ";
	}
	load(e) {
		if (this.containerDom = e, this.iframe) e.appendChild(this.iframe);
		else {
			console.warn("iframe not exits");
			return;
		}
		let t = this.getDocument(), n = this.getWindow();
		if (!(t && n)) return;
		let r = () => {
			this.iframeStatus = "LOADED";
			let e = this.readyQueue;
			this.readyQueue = [], e.forEach((e) => e()), t.removeEventListener("load", r);
		}, i = new Promise((e) => {
			this.iframe.addEventListener("load", () => {
				r(), e("finish");
			});
		}), a = this.getHTMLTemplate();
		return t.write(a), t.close(), i;
	}
	loadUrl(e) {
		return new Promise((t) => {
			let n = (e) => {
				t(e), this.iframe?.removeEventListener("load", n);
			};
			this.iframe?.addEventListener("load", n), this.iframe?.contentWindow?.location.replace(e);
		});
	}
	ready(e) {
		if (this.iframeStatus === "LOADED") {
			e();
			return;
		}
		this.iframeStatus === "INIT" && this.readyQueue.push(e);
	}
	onLoadFailed(e) {
		if (this.iframeStatus === "LOADED_FAILED") {
			e({ msg: this.loadError });
			return;
		}
		this.iframeStatus === "INIT" && this.errorQueue.push(e);
	}
	getWindow() {
		return this.iframe?.contentWindow;
	}
	getDocument() {
		return this.iframe?.contentDocument;
	}
	injectJS(e) {
		let t = this.getDocument();
		if (!t) return !1;
		let n = t.createElement("script");
		return n.src = e, new Promise((e, r) => {
			n.onload = e, n.onerror = r, t.head.appendChild(n);
		});
	}
	injectJsText(e) {
		let t = this.getDocument();
		if (!t) return !1;
		let n = t.createElement("script");
		return n.textContent = e, t.head.appendChild(n), !0;
	}
	injectStyleText(e) {
		let t = this.getDocument();
		if (!t) return !1;
		let n = t.createElement("style");
		return n.textContent = e, t.head.appendChild(n), !0;
	}
	destroy() {
		this.iframe?.parentNode?.removeChild(this.iframe), this.iframe = null;
	}
};
//#endregion
//#region src/utils/index.ts
function f(e, t, n, r) {
	return e.addEventListener(t, (e) => {
		e?.fixed || n(e);
	}, r), () => {
		e.removeEventListener(t, n);
	};
}
var p = (e) => {
	let t;
	return t = typeof HTMLElement == "object" ? function(e) {
		return e instanceof HTMLElement;
	} : function(e) {
		return e && typeof e == "object" && e.nodeType === 1 && typeof e.nodeName == "string";
	}, t(e);
}, m = (e) => {
	let t = 0, n = !0, r = (i) => {
		i - t >= 0 && (t = i, n && e()), requestAnimationFrame(r);
	};
	return requestAnimationFrame(r), () => {
		n = !1;
	};
}, h = {
	highlightBox: "_highlightBox_10hr6_1",
	borderDrawBox: "_borderDrawBox_10hr6_8",
	toolBox: "_toolBox_10hr6_15"
}, g = (e) => Number.parseFloat(e) || 0, _ = (e) => {
	let t = e.getBoundingClientRect(), n = e.ownerDocument.defaultView?.getComputedStyle(e);
	if (!n) return t;
	let r = g(n.marginLeft), i = g(n.marginRight), a = g(n.marginTop), o = g(n.marginBottom), s = t.width + r + i, c = t.height + a + o;
	return n.boxSizing !== "border-box" && (s += g(n.paddingLeft) + g(n.paddingRight) + g(n.borderLeftWidth) + g(n.borderRightWidth), c += g(n.paddingTop) + g(n.paddingBottom) + g(n.borderTopWidth) + g(n.borderBottomWidth)), new DOMRect(t.left - r, t.top - a, s, c);
}, v = ({ instance: e, toolbarView: t, getRef: i, onRefDestroy: a, style: d, children: f }) => {
	let [g, v] = s(), y = o(null), b = o(null), x = o(null), S = o();
	S.current = e;
	let ee = (t) => {
		let n = t.getDom(), r = e._NODE_MODEL.material?.value.rootSelector;
		return r && n && (n = n.querySelector?.(r) || n), !!p(n);
	};
	r(() => {
		let t = m(() => {
			w();
		});
		return i?.(y), e?._STATUS !== "DESTROY" && ee(e), () => {
			t(), a?.(y);
		};
	}, []);
	let C = n((e) => {
		if (x.current) {
			let t = (x.current?.children?.[0] || x.current).getBoundingClientRect(), n = t?.height || 0, r = Math.max(t?.width, e.width) || 0;
			e.top - n < 0 ? x.current.style.top = `calc( 100% + ${Math.floor(n)}px + 4px)` : x.current.style.top = "auto", x.current.style.width = `${r}px`;
		}
	}, []), w = n(() => {
		let t = S.current, n = null;
		if (t?._STATUS === "DESTROY") return;
		let r = t?.getDom();
		if (!r) return;
		let i = e._NODE_MODEL.material?.value.rootSelector;
		if (i && (r = r?.querySelector?.(i) || r), p(r)) n = r;
		else return;
		let a = _(n), o = `translate3d(${a?.left}px, ${a.top}px, 0)`, s = {
			width: a?.width + "px",
			height: a?.height + "px",
			transform: o
		};
		v(s);
		let c = document.getElementById(t?._UNIQUE_ID || "");
		c && (c.style.transform = o, c.style.width = a?.width + "px", c.style.height = a?.height + "px"), C(a);
	}, [e._NODE_MODEL.material?.value.rootSelector, C]);
	return r(() => {
		w();
	}, [e]), y.current = { update() {
		w();
	} }, g ? /* @__PURE__ */ u("div", {
		ref: b,
		className: h.highlightBox,
		id: e?._UNIQUE_ID,
		style: {
			...d,
			...g
		},
		children: [t && /* @__PURE__ */ l("div", {
			ref: x,
			className: h.toolBox,
			children: t
		}), f]
	}) : /* @__PURE__ */ l(c, {});
}, y = e.forwardRef(({ instances: e, toolbarView: t, style: n, children: r, containerStyle: a, itemRender: s }, c) => {
	let u = o([]);
	i(c, () => ({ update() {
		u.current.forEach((e) => {
			e.current?.update();
		});
	} }), []);
	let d = (e) => {
		let t = u.current || [];
		u.current = t.filter((t) => t !== e);
	};
	return /* @__PURE__ */ l("div", {
		className: h.borderDrawBox,
		style: a || {},
		children: e.map((e, i) => {
			if (!e || e._STATUS === "DESTROY") return null;
			let a = r;
			return s && (a = /* @__PURE__ */ l(s, {
				instance: e,
				index: i
			})), /* @__PURE__ */ l(v, {
				style: n,
				instance: e,
				toolbarView: t,
				getRef: (e) => {
					e.current && u.current.push(e);
				},
				onRefDestroy: d,
				children: a
			}, i);
		})
	});
});
//#endregion
//#region ../../node_modules/.pnpm/mitt@3.0.1/node_modules/mitt/dist/mitt.mjs
function b(e) {
	return {
		all: e ||= /* @__PURE__ */ new Map(),
		on: function(t, n) {
			var r = e.get(t);
			r ? r.push(n) : e.set(t, [n]);
		},
		off: function(t, n) {
			var r = e.get(t);
			r && (n ? r.splice(r.indexOf(n) >>> 0, 1) : e.set(t, []));
		},
		emit: function(t, n) {
			var r = e.get(t);
			r && r.slice().map(function(e) {
				e(n);
			}), (r = e.get("*")) && r.slice().map(function(e) {
				e(t, n);
			});
		}
	};
}
//#endregion
//#region src/core/dragAndDrop/emitter.ts
var x = class {
	emitter;
	constructor() {
		this.emitter = b();
	}
}, S = class extends x {
	eventPriority = 0;
	offset = {
		x: 0,
		y: 0
	};
	container;
	offsetDom;
	pointerScale = 1;
	canDrag = (e) => Promise.resolve(e);
	canDrop = (e) => Promise.resolve(e);
	eventDisposeQueue = [];
	name;
	getTargetSensor;
	constructor(e) {
		super(), this.name = e.name, this.eventPriority = e.eventPriority || this.eventPriority, this.container = e.container, e.offset && (this.offset = e.offset || {
			x: 0,
			y: 0
		}), this.offsetDom = e.offsetDom, this.pointerScale = e.pointerScale ?? this.pointerScale, this.registerEvent(), this.registerSyncOffsetEvent();
	}
	registerSyncOffsetEvent() {
		let e = this.offsetDom;
		if (!e) return;
		let t = window.setInterval(() => {
			let t = e.getBoundingClientRect();
			this.offset = {
				x: t.x,
				y: t.y
			};
		}, 250);
		this.eventDisposeQueue.push(() => {
			clearInterval(t);
		});
	}
	registerEvent() {
		let e = this.container;
		this.eventDisposeQueue.push(f(e, "mouseenter", (e) => {
			let t = this.getTargetSensor?.({
				sensor: this,
				event: e
			}) || {
				sensor: this,
				event: e
			};
			t.sensor.emitter.emit("mouseEnter", {
				sensor: t.sensor,
				event: t.event,
				pointer: t.sensor.getPointer(t.event)
			});
		})), this.eventDisposeQueue.push(f(e, "mouseleave", (e) => {
			let t = this.getTargetSensor?.({
				sensor: this,
				event: e
			}) || {
				sensor: this,
				event: e
			};
			t.sensor.emitter.emit("mouseLeave", {
				sensor: t.sensor,
				event: t.event,
				pointer: t.sensor.getPointer(t.event)
			});
		})), this.eventDisposeQueue.push(f(e, "mousedown", (e) => {
			if (e.button === 2) return;
			let t = this.getTargetSensor?.({
				sensor: this,
				event: e
			}) || {
				sensor: this,
				event: e
			}, n = t.sensor;
			n.emitter.emit("mouseChange", {
				sensor: t.sensor,
				event: t.event,
				pointer: t.sensor.getPointer(t.event)
			}), n.emitter.emit("mouseDown", {
				sensor: t.sensor,
				event: t.event,
				pointer: t.sensor.getPointer(t.event)
			});
		}, !0)), this.eventDisposeQueue.push(f(e, "mouseup", (e) => {
			let t = this.getTargetSensor?.({
				sensor: this,
				event: e
			}) || {
				sensor: this,
				event: e
			}, n = t.sensor;
			n.emitter.emit("mouseChange", {
				sensor: t.sensor,
				event: t.event,
				pointer: t.sensor.getPointer(t.event)
			}), n.emitter.emit("mouseUp", {
				sensor: t.sensor,
				event: t.event,
				pointer: t.sensor.getPointer(t.event)
			});
		}, !0)), this.eventDisposeQueue.push(f(e, "mousemove", (e) => {
			let t = this.getTargetSensor?.({
				sensor: this,
				event: e
			}) || {
				sensor: this,
				event: e
			}, n = t.sensor;
			n.emitter.emit("mouseMove", {
				sensor: t.sensor,
				event: t.event,
				pointer: t.sensor.getPointer(t.event)
			}), n.emitter.emit("mouseChange", {
				sensor: t.sensor,
				event: t.event,
				pointer: t.sensor.getPointer(t.event)
			});
		}, !0)), this.eventDisposeQueue.push(f(e, "click", (e) => {
			let t = this.getTargetSensor?.({
				sensor: this,
				event: e
			}) || {
				sensor: this,
				event: e
			};
			t.sensor.emitter.emit("click", {
				sensor: t.sensor,
				event: t.event,
				pointer: t.sensor.getPointer(t.event)
			});
		}, !0));
	}
	getPointer(e) {
		let t = typeof this.pointerScale == "function" ? this.pointerScale() : this.pointerScale;
		return {
			x: this.offset.x + e.clientX * t,
			y: this.offset.y + e.clientY * t
		};
	}
	updateOffset(e) {
		this.offset = e;
	}
	getOffset() {
		return this.offset;
	}
	setCanDrag(e) {
		this.canDrag = e;
	}
	setCanDrop(e) {
		this.canDrop = e;
	}
	destroy() {
		this.eventDisposeQueue.forEach((e) => e());
	}
}, ee = typeof global == "object" && global && global.Object === Object && global, C = typeof self == "object" && self && self.Object === Object && self, w = ee || C || Function("return this")(), T = w.Symbol, E = Object.prototype, D = E.hasOwnProperty, te = E.toString, O = T ? T.toStringTag : void 0;
function ne(e) {
	var t = D.call(e, O), n = e[O];
	try {
		e[O] = void 0;
		var r = !0;
	} catch {}
	var i = te.call(e);
	return r && (t ? e[O] = n : delete e[O]), i;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_objectToString.js
var re = Object.prototype.toString;
function ie(e) {
	return re.call(e);
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_baseGetTag.js
var ae = "[object Null]", oe = "[object Undefined]", se = T ? T.toStringTag : void 0;
function ce(e) {
	return e == null ? e === void 0 ? oe : ae : se && se in Object(e) ? ne(e) : ie(e);
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/isObjectLike.js
function le(e) {
	return typeof e == "object" && !!e;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/isSymbol.js
var ue = "[object Symbol]";
function de(e) {
	return typeof e == "symbol" || le(e) && ce(e) == ue;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_arrayMap.js
function fe(e, t) {
	for (var n = -1, r = e == null ? 0 : e.length, i = Array(r); ++n < r;) i[n] = t(e[n], n, e);
	return i;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_trimmedEndIndex.js
var pe = /\s/;
function me(e) {
	for (var t = e.length; t-- && pe.test(e.charAt(t)););
	return t;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_baseTrim.js
var he = /^\s+/;
function ge(e) {
	return e && e.slice(0, me(e) + 1).replace(he, "");
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/isObject.js
function k(e) {
	var t = typeof e;
	return e != null && (t == "object" || t == "function");
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/toNumber.js
var _e = NaN, ve = /^[-+]0x[0-9a-f]+$/i, ye = /^0b[01]+$/i, be = /^0o[0-7]+$/i, xe = parseInt;
function Se(e) {
	if (typeof e == "number") return e;
	if (de(e)) return _e;
	if (k(e)) {
		var t = typeof e.valueOf == "function" ? e.valueOf() : e;
		e = k(t) ? t + "" : t;
	}
	if (typeof e != "string") return e === 0 ? e : +e;
	e = ge(e);
	var n = ye.test(e);
	return n || be.test(e) ? xe(e.slice(2), n ? 2 : 8) : ve.test(e) ? _e : +e;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/identity.js
function Ce(e) {
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/isFunction.js
var we = "[object AsyncFunction]", Te = "[object Function]", Ee = "[object GeneratorFunction]", De = "[object Proxy]";
function Oe(e) {
	if (!k(e)) return !1;
	var t = ce(e);
	return t == Te || t == Ee || t == we || t == De;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_coreJsData.js
var ke = w["__core-js_shared__"], Ae = function() {
	var e = /[^.]+$/.exec(ke && ke.keys && ke.keys.IE_PROTO || "");
	return e ? "Symbol(src)_1." + e : "";
}();
function je(e) {
	return !!Ae && Ae in e;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_toSource.js
var Me = Function.prototype.toString;
function Ne(e) {
	if (e != null) {
		try {
			return Me.call(e);
		} catch {}
		try {
			return e + "";
		} catch {}
	}
	return "";
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_baseIsNative.js
var Pe = /[\\^$.*+?()[\]{}|]/g, Fe = /^\[object .+?Constructor\]$/, Ie = Function.prototype, Le = Object.prototype, Re = Ie.toString, ze = Le.hasOwnProperty, Be = RegExp("^" + Re.call(ze).replace(Pe, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function Ve(e) {
	return !k(e) || je(e) ? !1 : (Oe(e) ? Be : Fe).test(Ne(e));
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_getValue.js
function He(e, t) {
	return e?.[t];
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_getNative.js
function Ue(e, t) {
	var n = He(e, t);
	return Ve(n) ? n : void 0;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_apply.js
function We(e, t, n) {
	switch (n.length) {
		case 0: return e.call(t);
		case 1: return e.call(t, n[0]);
		case 2: return e.call(t, n[0], n[1]);
		case 3: return e.call(t, n[0], n[1], n[2]);
	}
	return e.apply(t, n);
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_shortOut.js
var Ge = 800, Ke = 16, qe = Date.now;
function Je(e) {
	var t = 0, n = 0;
	return function() {
		var r = qe(), i = Ke - (r - n);
		if (n = r, i > 0) {
			if (++t >= Ge) return arguments[0];
		} else t = 0;
		return e.apply(void 0, arguments);
	};
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/constant.js
function Ye(e) {
	return function() {
		return e;
	};
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_defineProperty.js
var Xe = function() {
	try {
		var e = Ue(Object, "defineProperty");
		return e({}, "", {}), e;
	} catch {}
}(), Ze = Je(Xe ? function(e, t) {
	return Xe(e, "toString", {
		configurable: !0,
		enumerable: !1,
		value: Ye(t),
		writable: !0
	});
} : Ce);
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_baseFindIndex.js
function Qe(e, t, n, r) {
	for (var i = e.length, a = n + (r ? 1 : -1); r ? a-- : ++a < i;) if (t(e[a], a, e)) return a;
	return -1;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_baseIsNaN.js
function $e(e) {
	return e !== e;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_strictIndexOf.js
function et(e, t, n) {
	for (var r = n - 1, i = e.length; ++r < i;) if (e[r] === t) return r;
	return -1;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_baseIndexOf.js
function tt(e, t, n) {
	return t === t ? et(e, t, n) : Qe(e, $e, n);
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_arrayIncludes.js
function nt(e, t) {
	return !!(e != null && e.length) && tt(e, t, 0) > -1;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/eq.js
function rt(e, t) {
	return e === t || e !== e && t !== t;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_overRest.js
var it = Math.max;
function at(e, t, n) {
	return t = it(t === void 0 ? e.length - 1 : t, 0), function() {
		for (var r = arguments, i = -1, a = it(r.length - t, 0), o = Array(a); ++i < a;) o[i] = r[t + i];
		i = -1;
		for (var s = Array(t + 1); ++i < t;) s[i] = r[i];
		return s[t] = n(o), We(e, this, s);
	};
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_baseRest.js
function ot(e, t) {
	return Ze(at(e, t, Ce), e + "");
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/isLength.js
var st = 9007199254740991;
function ct(e) {
	return typeof e == "number" && e > -1 && e % 1 == 0 && e <= st;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/isArrayLike.js
function lt(e) {
	return e != null && ct(e.length) && !Oe(e);
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_baseUnary.js
function ut(e) {
	return function(t) {
		return e(t);
	};
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_overArg.js
function dt(e, t) {
	return function(n) {
		return e(t(n));
	};
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_nativeCreate.js
var A = Ue(Object, "create");
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_hashClear.js
function ft() {
	this.__data__ = A ? A(null) : {}, this.size = 0;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_hashDelete.js
function pt(e) {
	var t = this.has(e) && delete this.__data__[e];
	return this.size -= +!!t, t;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_hashGet.js
var mt = "__lodash_hash_undefined__", ht = Object.prototype.hasOwnProperty;
function gt(e) {
	var t = this.__data__;
	if (A) {
		var n = t[e];
		return n === mt ? void 0 : n;
	}
	return ht.call(t, e) ? t[e] : void 0;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_hashHas.js
var _t = Object.prototype.hasOwnProperty;
function vt(e) {
	var t = this.__data__;
	return A ? t[e] !== void 0 : _t.call(t, e);
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_hashSet.js
var yt = "__lodash_hash_undefined__";
function bt(e, t) {
	var n = this.__data__;
	return this.size += +!this.has(e), n[e] = A && t === void 0 ? yt : t, this;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_Hash.js
function j(e) {
	var t = -1, n = e == null ? 0 : e.length;
	for (this.clear(); ++t < n;) {
		var r = e[t];
		this.set(r[0], r[1]);
	}
}
j.prototype.clear = ft, j.prototype.delete = pt, j.prototype.get = gt, j.prototype.has = vt, j.prototype.set = bt;
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_listCacheClear.js
function xt() {
	this.__data__ = [], this.size = 0;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_assocIndexOf.js
function St(e, t) {
	for (var n = e.length; n--;) if (rt(e[n][0], t)) return n;
	return -1;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_listCacheDelete.js
var Ct = Array.prototype.splice;
function wt(e) {
	var t = this.__data__, n = St(t, e);
	return n < 0 ? !1 : (n == t.length - 1 ? t.pop() : Ct.call(t, n, 1), --this.size, !0);
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_listCacheGet.js
function Tt(e) {
	var t = this.__data__, n = St(t, e);
	return n < 0 ? void 0 : t[n][1];
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_listCacheHas.js
function Et(e) {
	return St(this.__data__, e) > -1;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_listCacheSet.js
function Dt(e, t) {
	var n = this.__data__, r = St(n, e);
	return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_ListCache.js
function M(e) {
	var t = -1, n = e == null ? 0 : e.length;
	for (this.clear(); ++t < n;) {
		var r = e[t];
		this.set(r[0], r[1]);
	}
}
M.prototype.clear = xt, M.prototype.delete = wt, M.prototype.get = Tt, M.prototype.has = Et, M.prototype.set = Dt;
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_Map.js
var Ot = Ue(w, "Map");
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_mapCacheClear.js
function kt() {
	this.size = 0, this.__data__ = {
		hash: new j(),
		map: new (Ot || M)(),
		string: new j()
	};
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_isKeyable.js
function At(e) {
	var t = typeof e;
	return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_getMapData.js
function jt(e, t) {
	var n = e.__data__;
	return At(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_mapCacheDelete.js
function Mt(e) {
	var t = jt(this, e).delete(e);
	return this.size -= +!!t, t;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_mapCacheGet.js
function Nt(e) {
	return jt(this, e).get(e);
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_mapCacheHas.js
function Pt(e) {
	return jt(this, e).has(e);
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_mapCacheSet.js
function Ft(e, t) {
	var n = jt(this, e), r = n.size;
	return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_MapCache.js
function N(e) {
	var t = -1, n = e == null ? 0 : e.length;
	for (this.clear(); ++t < n;) {
		var r = e[t];
		this.set(r[0], r[1]);
	}
}
N.prototype.clear = kt, N.prototype.delete = Mt, N.prototype.get = Nt, N.prototype.has = Pt, N.prototype.set = Ft;
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_getPrototype.js
var It = dt(Object.getPrototypeOf, Object), Lt = "[object Object]", Rt = Function.prototype, zt = Object.prototype, Bt = Rt.toString, Vt = zt.hasOwnProperty, Ht = Bt.call(Object);
function Ut(e) {
	if (!le(e) || ce(e) != Lt) return !1;
	var t = It(e);
	if (t === null) return !0;
	var n = Vt.call(t, "constructor") && t.constructor;
	return typeof n == "function" && n instanceof n && Bt.call(n) == Ht;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_setCacheAdd.js
var Wt = "__lodash_hash_undefined__";
function Gt(e) {
	return this.__data__.set(e, Wt), this;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_setCacheHas.js
function Kt(e) {
	return this.__data__.has(e);
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_SetCache.js
function qt(e) {
	var t = -1, n = e == null ? 0 : e.length;
	for (this.__data__ = new N(); ++t < n;) this.add(e[t]);
}
qt.prototype.add = qt.prototype.push = Gt, qt.prototype.has = Kt;
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_cacheHas.js
function Jt(e, t) {
	return e.has(t);
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/now.js
var Yt = function() {
	return w.Date.now();
}, Xt = "Expected a function", Zt = Math.max, Qt = Math.min;
function $t(e, t, n) {
	var r, i, a, o, s, c, l = 0, u = !1, d = !1, f = !0;
	if (typeof e != "function") throw TypeError(Xt);
	t = Se(t) || 0, k(n) && (u = !!n.leading, d = "maxWait" in n, a = d ? Zt(Se(n.maxWait) || 0, t) : a, f = "trailing" in n ? !!n.trailing : f);
	function p(t) {
		var n = r, a = i;
		return r = i = void 0, l = t, o = e.apply(a, n), o;
	}
	function m(e) {
		return l = e, s = setTimeout(_, t), u ? p(e) : o;
	}
	function h(e) {
		var n = e - c, r = e - l, i = t - n;
		return d ? Qt(i, a - r) : i;
	}
	function g(e) {
		var n = e - c, r = e - l;
		return c === void 0 || n >= t || n < 0 || d && r >= a;
	}
	function _() {
		var e = Yt();
		if (g(e)) return v(e);
		s = setTimeout(_, h(e));
	}
	function v(e) {
		return s = void 0, f && r ? p(e) : (r = i = void 0, o);
	}
	function y() {
		s !== void 0 && clearTimeout(s), l = 0, r = c = i = s = void 0;
	}
	function b() {
		return s === void 0 ? o : v(Yt());
	}
	function x() {
		var e = Yt(), n = g(e);
		if (r = arguments, i = this, c = e, n) {
			if (s === void 0) return m(c);
			if (d) return clearTimeout(s), s = setTimeout(_, t), p(c);
		}
		return s === void 0 && (s = setTimeout(_, t)), o;
	}
	return x.cancel = y, x.flush = b, x;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/isArrayLikeObject.js
function en(e) {
	return le(e) && lt(e);
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_arrayIncludesWith.js
function tn(e, t, n) {
	for (var r = -1, i = e == null ? 0 : e.length; ++r < i;) if (n(t, e[r])) return !0;
	return !1;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_baseIntersection.js
var nn = Math.min;
function rn(e, t, n) {
	for (var r = n ? tn : nt, i = e[0].length, a = e.length, o = a, s = Array(a), c = Infinity, l = []; o--;) {
		var u = e[o];
		o && t && (u = fe(u, ut(t))), c = nn(u.length, c), s[o] = !n && (t || i >= 120 && u.length >= 120) ? new qt(o && u) : void 0;
	}
	u = e[0];
	var d = -1, f = s[0];
	outer: for (; ++d < i && l.length < c;) {
		var p = u[d], m = t ? t(p) : p;
		if (p = n || p !== 0 ? p : 0, !(f ? Jt(f, m) : r(l, m, n))) {
			for (o = a; --o;) {
				var h = s[o];
				if (!(h ? Jt(h, m) : r(e[o], m, n))) continue outer;
			}
			f && f.push(m), l.push(p);
		}
	}
	return l;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_castArrayLikeObject.js
function an(e) {
	return en(e) ? e : [];
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/intersection.js
var on = ot(function(e) {
	var t = fe(e, an);
	return t.length && t[0] === e[0] ? rn(t) : [];
}), sn = class {
	senors = [];
	senorEventPriorityQueueMap = {};
	doc;
	pointer = {
		x: 0,
		y: 0
	};
	shakeDistance = 4;
	eventHandler = [];
	currentSensor = null;
	currentState = "NORMAL";
	dragStartObj = null;
	emitter = b();
	canTriggerClick = !0;
	recoverEventList = [];
	mousePressStatus = "UP";
	ignoredPointerSequence = !1;
	win;
	globalSenor;
	constructor(e) {
		this.preventDefaultEvent(), this.doc = e.doc, this.win = e.win, e.dragConfig?.shakeDistance !== void 0 && (this.shakeDistance = e.dragConfig?.shakeDistance);
		let t = new S({
			name: "globalSensor",
			container: e.doc,
			mainDocument: document
		});
		t.setCanDrag(async () => null), t.emitter.on("mouseDown", async (e) => {
			if (this.isDndIgnoredEvent(e.event)) {
				this.ignoredPointerSequence = !0;
				return;
			}
			this.emitter.emit("mouseDown", e), this.mousePressStatus = "DOWN";
		}), t.emitter.on("mouseMove", async (e) => {
			if (this.ignoredPointerSequence || (this.emitter.emit("mouseMove", e), this.currentState !== "DRAGGING" || this.currentSensor !== null)) return;
			let n = await t.canDrop({
				...e,
				extraData: { ...this.dragStartObj.extraData }
			});
			if (!n) return;
			let { pointer: r, event: i } = e, a = {};
			typeof n != "boolean" && (a = n.extraData || {});
			let o = {
				from: this.dragStartObj.event,
				fromSensor: this.dragStartObj.sensor,
				fromPointer: this.dragStartObj.pointer,
				extraData: {
					...this.dragStartObj.extraData,
					...a
				},
				current: i,
				currentSensor: t,
				pointer: r
			}, s = "dragging";
			this.emitter.emit(s, o), this.batchSensorEmit(s, o);
		}), t.emitter.on("mouseUp", (e) => {
			if (this.ignoredPointerSequence) {
				this.ignoredPointerSequence = !1, this.mousePressStatus = "UP", this.currentState = "NORMAL", this.dragStartObj = null, this.recoverEventList = [];
				return;
			}
			this.senors.find((t) => {
				let n = t.container, r = e.event.target;
				return n.contains(r);
			}) || (this.mousePressStatus = "UP", this.currentState = "NORMAL", this.dragStartObj = null, this.batchSensorEmit("dragEnd", {}));
		}), this.globalSenor = t;
	}
	isDndIgnoredEvent(e) {
		return !!e.target?.closest?.("[data-chameleon-dnd-ignore=\"true\"]");
	}
	preventDefaultEvent() {
		document.addEventListener("contextmenu", (e) => {
			e.preventDefault();
		});
	}
	batchSensorEmit(e, t) {
		this.senors.forEach((n) => {
			n.emitter.emit(e, t);
		});
	}
	registerSensor(e) {
		e.getTargetSensor = this.getTargetSensor.bind(this), this.senors.push(e), e.emitter.on("click", (e) => {
			this.canTriggerClick && this.emitter.emit("click", {
				sensor: e.sensor,
				event: e.event,
				pointer: e.pointer
			});
		});
		let t = (e) => {
			this.mousePressStatus = "DOWN", this.recoverEventList.push({
				name: "mousedown",
				event: e.event
			}), this.dragStartObj = e;
		};
		e.emitter.on("mouseDown", t), this.eventHandler.push(() => {
			e.emitter.off("mouseDown", t);
		});
		let n = async (e) => {
			if (this.mousePressStatus === "DOWN" && this.recoverEventList.push({
				name: "mousemove",
				event: e.event
			}), this.currentState === "CANCEL") return;
			let { sensor: t, pointer: n, event: r } = e;
			if (r.buttons === 0) {
				this.resetDrag();
				return;
			}
			if (this.emitter.emit("mouseMove", e), this.currentState === "NORMAL") {
				if (this.dragStartObj === null || t !== this.dragStartObj?.sensor) return;
				let e = n, r = this.dragStartObj.pointer, i = this.shakeDistance;
				if (!((e.y - r.y) ** 2 + (e.x - r.x) ** 2 > i)) return;
				let a = await this.dragStartObj.sensor.canDrag(this.dragStartObj);
				if (!a) return;
				typeof a != "boolean" && (this.dragStartObj = a), this.currentState = "DRAGGING";
				let o = "dragStart", s = {
					from: this.dragStartObj.event,
					fromSensor: this.dragStartObj.sensor,
					fromPointer: n,
					pointer: this.dragStartObj.pointer,
					extraData: this.dragStartObj.extraData || {}
				};
				this.emitter.emit(o, s), this.batchSensorEmit(o, s);
				return;
			}
			let i = await t.canDrop({
				...e,
				extraData: { ...this.dragStartObj.extraData }
			});
			if (i === !1) return;
			let a = {};
			typeof i != "boolean" && (a = i?.extraData || {});
			let o = {
				from: this.dragStartObj.event,
				fromSensor: this.dragStartObj.sensor,
				fromPointer: this.dragStartObj.pointer,
				extraData: {
					...this.dragStartObj.extraData,
					...a
				},
				current: r,
				currentSensor: t,
				pointer: n
			}, s = "dragging";
			this.emitter.emit(s, o), this.batchSensorEmit(s, o);
		};
		e.emitter.on("mouseMove", n), this.eventHandler.push(() => {
			e?.emitter.off("mouseMove", n);
		});
		let r = async ({ sensor: e, event: t, pointer: n }) => {
			if (this.mousePressStatus = "UP", this.currentState === "NORMAL") {
				let e = this.recoverEventList;
				this.recoverEventList = [], e.push({
					name: "mouseup",
					event: t
				}), e.forEach((e) => {
					let t = new Event(e.name, e.event);
					t.fixed = !0, e.event.target?.dispatchEvent(t);
				});
			}
			if (this.currentState === "DRAGGING") {
				this.canTriggerClick = !1, setTimeout(() => {
					this.canTriggerClick = !0;
				}, 16.66);
				let r = await e.canDrop({
					sensor: e,
					event: t,
					pointer: n,
					extraData: { ...this.dragStartObj.extraData }
				});
				if (r !== !1) {
					let i = {};
					typeof r != "boolean" && (i = r?.extraData || {});
					let a = "drop", o = {
						from: this.dragStartObj.event,
						fromSensor: this.dragStartObj.sensor,
						fromPointer: this.dragStartObj.pointer,
						extraData: {
							...this.dragStartObj.extraData,
							...i
						},
						current: t,
						currentSensor: e,
						pointer: n
					};
					this.emitter.emit(a, o), this.batchSensorEmit(a, o);
				}
			}
			let r = "dragEnd", i = {
				from: this.dragStartObj?.event,
				fromSensor: this.dragStartObj?.sensor,
				fromPointer: this.dragStartObj?.pointer,
				extraData: this.dragStartObj?.extraData || {},
				current: t,
				currentSensor: e,
				pointer: n
			};
			this.emitter.emit(r, i), this.batchSensorEmit(r, i), this.currentState = "NORMAL", this.dragStartObj = null;
		};
		e.emitter.on("mouseUp", r), this.eventHandler.push(() => {
			e.emitter.off("mouseUp", r);
		}), e.emitter.on("mouseEnter", () => {
			this.currentSensor = e;
		}), e.emitter.on("mouseLeave", () => {
			this.currentSensor = null;
		}), this.eventHandler.push(() => {
			e.emitter.off("mouseUp", r);
		});
	}
	flushSenorEventPriorityQueueMap = $t((e) => {
		let t = this.senorEventPriorityQueueMap[e];
		this.senorEventPriorityQueueMap[e] = [], t.sort((e, t) => t.priority - e.priority), t.forEach((e) => {
			e.handle();
		});
	}, 10);
	cancelDrag() {
		this.currentState = "CANCEL";
	}
	resetDrag() {
		this.currentState = "NORMAL";
	}
	clearSensors() {
		let e = this.senors;
		this.senors = [];
		let t = this.eventHandler;
		this.eventHandler = [], t.forEach((e) => e()), e.forEach((e) => e.destroy()), this.currentSensor = null, this.currentState = "NORMAL", this.dragStartObj = null, this.mousePressStatus = "UP", this.recoverEventList = [];
	}
	getTargetSensor(e) {
		let { sensor: t, event: n } = e, r = n.clientX, i = n.clientY, a = {
			clientX: r,
			clientY: i,
			target: n.target,
			sourceEvent: n
		}, o = t;
		if (r < 0 || i < 0) {
			let e = t.getOffset(), n = r + e.x, s = i + e.y;
			a.clientX = n, a.clientY = s;
			let c = document.elementFromPoint(n, s);
			c ? (a.target = c, o = this.findSensorByDom(c) || this.globalSenor) : o = this.globalSenor;
		}
		return {
			sensor: o,
			event: a
		};
	}
	findSensorByDom(e) {
		return this.senors.find((t) => t.container.contains(e));
	}
}, P = {
	highlightBox: "_highlightBox_1dlxo_1",
	borderDrawBox: "_borderDrawBox_1dlxo_6",
	toolBox: "_toolBox_1dlxo_16",
	horizontal: "_horizontal_1dlxo_24",
	before: "_before_1dlxo_24",
	after: "_after_1dlxo_27",
	vertical: "_vertical_1dlxo_31",
	current: "_current_1dlxo_38"
};
//#endregion
//#region ../../node_modules/.pnpm/clsx@1.2.1/node_modules/clsx/dist/clsx.m.js
function cn(e) {
	var t, n, r = "";
	if (typeof e == "string" || typeof e == "number") r += e;
	else if (typeof e == "object") {
		if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (n = cn(e[t])) && (r && (r += " "), r += n);
		else for (t in e) e[t] && (r && (r += " "), r += t);
	}
	return r;
}
function ln() {
	for (var e, t, n = 0, r = ""; n < arguments.length;) (e = arguments[n++]) && (t = cn(e)) && (r && (r += " "), r += t);
	return r;
}
//#endregion
//#region src/components/DropAnchor/index.tsx
function un(e) {
	let { instance: t, toolRenderView: i, getRef: a, onRefDestroy: d, style: f, mouseEvent: h, onDropInfoChange: g, dropInfo: _, customDropViewRender: v } = e, [y, b] = s({}), [x, S] = s([]), [ee, C] = s(), w = o(null), [T, E] = s({
		width: 0,
		height: 0
	}), D = o(null), [te, O] = s();
	r(() => {
		if (a?.(w), t?._STATUS === "DESTROY") return;
		let e = t.getDom();
		return p(e) && O(e), () => {
			d?.(w);
		};
	}, []);
	let ne = o();
	ne.current = () => {
		let e = D.current?.getBoundingClientRect();
		e && E({
			width: e.width,
			height: e.height
		});
	}, r(() => {
		let e = m(() => {
			ne.current?.();
		});
		return () => {
			e();
		};
	}, []);
	let re = n(() => {
		let e = null;
		if (t?._STATUS === "DESTROY") return;
		let n = t.getDom();
		if (p(n)) e = n, O(e);
		else return;
		if (!h) return g?.(null), null;
		if (!t?._NODE_MODEL) {
			console.warn("node not exits");
			return;
		}
		let r = e.getBoundingClientRect();
		if (C(r), _.pos === "current") {
			let e = `translate3d(${r?.left}px, ${r.top}px, 0)`;
			b({
				width: `${r.width}px`,
				height: `${r.height}px`,
				transform: e
			});
		} else {
			let e = `translate3d(${r?.left - 2}px, ${r.top - 2}px, 0)`, n = {
				width: r?.width + 4 + "px",
				height: r?.height + 4 + "px",
				transform: e
			}, i = document.getElementById(t?._UNIQUE_ID || "");
			i && (i.style.transform = e, i.style.width = r?.width + "px", i.style.height = r?.height + "px"), b(n);
		}
		let i = {
			horizontal: P.horizontal,
			vertical: P.vertical,
			before: P.before,
			after: P.after,
			current: P.current
		}, a = _;
		h?.extraData.dropPosInfo && (a = {
			..._,
			...h?.extraData.dropPosInfo
		});
		let o = [i[_.direction], i[_.pos]];
		S(o), g?.(a);
	}, [
		_,
		t,
		h,
		g
	]);
	r(() => {
		re();
	}, [
		t,
		h,
		re
	]), w.current = { update() {
		re();
	} };
	let ie = /* @__PURE__ */ l("div", {
		style: {
			width: "100%",
			height: "100%"
		},
		className: ln([...x])
	});
	return v && (ie = /* @__PURE__ */ l(v, { ...e })), !te || !t ? /* @__PURE__ */ l(c, {}) : /* @__PURE__ */ u("div", {
		className: ln([P.highlightBox]),
		id: t?._UNIQUE_ID,
		style: {
			...f,
			opacity: +!!ee
		},
		children: [i && /* @__PURE__ */ l("div", {
			ref: D,
			className: P.toolBox,
			style: {
				top: `-${T.height + 5}px`,
				opacity: +!!T.width
			},
			children: i
		}), /* @__PURE__ */ l("div", {
			style: { ...y },
			children: ie
		})]
	});
}
function dn({ instances: e, toolRenderView: n, style: r, mouseEvent: a, dropInfos: c, ...u }, d) {
	let [f, p] = s(0), m = o([]);
	i(d, () => ({ update() {
		p(f + 1), m.current.forEach((e) => {
			e.current?.update();
		});
	} }), [p, f]);
	let h = (e) => {
		let t = m.current || [];
		m.current = t.filter((t) => t !== e);
	};
	return /* @__PURE__ */ l("div", {
		className: P.borderDrawBox,
		children: e.map((e, i) => e ? /* @__PURE__ */ t(un, {
			...u,
			mouseEvent: a,
			style: r,
			key: e?._UNIQUE_ID,
			instance: e,
			toolRenderView: n,
			dropInfo: c[i],
			getRef: (e) => {
				e.current && m.current.push(e);
			},
			onRefDestroy: h
		}) : null)
	});
}
var fn = e.forwardRef(dn), pn = class extends TypeError {
	constructor(e, t) {
		let n, { message: r, ...i } = e, { path: a } = e, o = a.length === 0 ? r : `At path: ${a.join(".")} -- ${r}`;
		super(o), this.value = void 0, this.key = void 0, this.type = void 0, this.refinement = void 0, this.path = void 0, this.branch = void 0, this.failures = void 0, Object.assign(this, i), this.name = this.constructor.name, this.failures = () => n ??= [e, ...t()];
	}
};
function mn(e) {
	return F(e) && typeof e[Symbol.iterator] == "function";
}
function F(e) {
	return typeof e == "object" && !!e;
}
function I(e) {
	return typeof e == "symbol" ? e.toString() : typeof e == "string" ? JSON.stringify(e) : `${e}`;
}
function hn(e) {
	let { done: t, value: n } = e.next();
	return t ? void 0 : n;
}
function gn(e, t, n, r) {
	if (e === !0) return;
	e === !1 ? e = {} : typeof e == "string" && (e = { message: e });
	let { path: i, branch: a } = t, { type: o } = n, { refinement: s, message: c = `Expected a value of type \`${o}\`${s ? ` with refinement \`${s}\`` : ""}, but received: \`${I(r)}\`` } = e;
	return {
		value: r,
		type: o,
		refinement: s,
		key: i[i.length - 1],
		path: i,
		branch: a,
		...e,
		message: c
	};
}
function* _n(e, t, n, r) {
	mn(e) || (e = [e]);
	for (let i of e) {
		let e = gn(i, t, n, r);
		e && (yield e);
	}
}
function* vn(e, t, n) {
	n === void 0 && (n = {});
	let { path: r = [], branch: i = [e], coerce: a = !1, mask: o = !1 } = n, s = {
		path: r,
		branch: i
	};
	if (a && (e = t.coercer(e, s), o && t.type !== "type" && F(t.schema) && F(e) && !Array.isArray(e))) for (let n in e) t.schema[n] === void 0 && delete e[n];
	let c = "valid";
	for (let n of t.validator(e, s)) c = "not_valid", yield [n, void 0];
	for (let [n, l, u] of t.entries(e, s)) {
		let t = vn(l, u, {
			path: n === void 0 ? r : [...r, n],
			branch: n === void 0 ? i : [...i, l],
			coerce: a,
			mask: o
		});
		for (let r of t) r[0] ? (c = r[0].refinement == null ? "not_valid" : "not_refined", yield [r[0], void 0]) : a && (l = r[1], n === void 0 ? e = l : e instanceof Map ? e.set(n, l) : e instanceof Set ? e.add(l) : F(e) && (l !== void 0 || n in e) && (e[n] = l));
	}
	if (c !== "not_valid") for (let n of t.refiner(e, s)) c = "not_refined", yield [n, void 0];
	c === "valid" && (yield [void 0, e]);
}
var L = class {
	constructor(e) {
		this.TYPE = void 0, this.type = void 0, this.schema = void 0, this.coercer = void 0, this.validator = void 0, this.refiner = void 0, this.entries = void 0;
		let { type: t, schema: n, validator: r, refiner: i, coercer: a = (e) => e, entries: o = function* () {} } = e;
		this.type = t, this.schema = n, this.entries = o, this.coercer = a, this.validator = r ? (e, t) => _n(r(e, t), t, this, e) : () => [], this.refiner = i ? (e, t) => _n(i(e, t), t, this, e) : () => [];
	}
	assert(e) {
		return yn(e, this);
	}
	create(e) {
		return bn(e, this);
	}
	is(e) {
		return Sn(e, this);
	}
	mask(e) {
		return xn(e, this);
	}
	validate(e, t) {
		return t === void 0 && (t = {}), R(e, this, t);
	}
};
function yn(e, t) {
	let n = R(e, t);
	if (n[0]) throw n[0];
}
function bn(e, t) {
	let n = R(e, t, { coerce: !0 });
	if (n[0]) throw n[0];
	return n[1];
}
function xn(e, t) {
	let n = R(e, t, {
		coerce: !0,
		mask: !0
	});
	if (n[0]) throw n[0];
	return n[1];
}
function Sn(e, t) {
	return !R(e, t)[0];
}
function R(e, t, n) {
	n === void 0 && (n = {});
	let r = vn(e, t, n), i = hn(r);
	return i[0] ? [new pn(i[0], function* () {
		for (let e of r) e[0] && (yield e[0]);
	}), void 0] : [void 0, i[1]];
}
function Cn() {
	var e = [...arguments];
	let t = e[0].type === "type", n = e.map((e) => e.schema), r = Object.assign({}, ...n);
	return t ? kn(r) : G(r);
}
function z(e, t) {
	return new L({
		type: e,
		schema: null,
		validator: t
	});
}
function B(e) {
	return new L({
		type: "dynamic",
		schema: null,
		*entries(t, n) {
			yield* e(t, n).entries(t, n);
		},
		validator(t, n) {
			return e(t, n).validator(t, n);
		},
		coercer(t, n) {
			return e(t, n).coercer(t, n);
		},
		refiner(t, n) {
			return e(t, n).refiner(t, n);
		}
	});
}
function wn(e, t) {
	let { schema: n } = e, r = { ...n };
	for (let e of t) delete r[e];
	switch (e.type) {
		case "type": return kn(r);
		default: return G(r);
	}
}
function V() {
	return z("any", () => !0);
}
function H(e) {
	return new L({
		type: "array",
		schema: e,
		*entries(t) {
			if (e && Array.isArray(t)) for (let [n, r] of t.entries()) yield [
				n,
				r,
				e
			];
		},
		coercer(e) {
			return Array.isArray(e) ? e.slice() : e;
		},
		validator(e) {
			return Array.isArray(e) || `Expected an array value, but received: ${I(e)}`;
		}
	});
}
function U() {
	return z("boolean", (e) => typeof e == "boolean");
}
function Tn(e) {
	let t = {}, n = e.map((e) => I(e)).join();
	for (let n of e) t[n] = n;
	return new L({
		type: "enums",
		schema: t,
		validator(t) {
			return e.includes(t) || `Expected one of \`${n}\`, but received: ${I(t)}`;
		}
	});
}
function En() {
	return z("func", (e) => typeof e == "function" || `Expected a function, but received: ${I(e)}`);
}
function W(e) {
	let t = I(e), n = typeof e;
	return new L({
		type: "literal",
		schema: n === "string" || n === "number" || n === "boolean" ? e : null,
		validator(n) {
			return n === e || `Expected the literal \`${t}\`, but received: ${I(n)}`;
		}
	});
}
function Dn() {
	return z("never", () => !1);
}
function On() {
	return z("number", (e) => typeof e == "number" && !isNaN(e) || `Expected a number, but received: ${I(e)}`);
}
function G(e) {
	let t = e ? Object.keys(e) : [], n = Dn();
	return new L({
		type: "object",
		schema: e || null,
		*entries(r) {
			if (e && F(r)) {
				let i = new Set(Object.keys(r));
				for (let n of t) i.delete(n), yield [
					n,
					r[n],
					e[n]
				];
				for (let e of i) yield [
					e,
					r[e],
					n
				];
			}
		},
		validator(e) {
			return F(e) || `Expected an object, but received: ${I(e)}`;
		},
		coercer(e) {
			return F(e) ? { ...e } : e;
		}
	});
}
function K(e) {
	return new L({
		...e,
		validator: (t, n) => t === void 0 || e.validator(t, n),
		refiner: (t, n) => t === void 0 || e.refiner(t, n)
	});
}
function q(e, t) {
	return new L({
		type: "record",
		schema: null,
		*entries(n) {
			if (F(n)) for (let r in n) {
				let i = n[r];
				yield [
					r,
					r,
					e
				], yield [
					r,
					i,
					t
				];
			}
		},
		validator(e) {
			return F(e) || `Expected an object, but received: ${I(e)}`;
		}
	});
}
function J() {
	return z("string", (e) => typeof e == "string" || `Expected a string, but received: ${I(e)}`);
}
function kn(e) {
	let t = Object.keys(e);
	return new L({
		type: "type",
		schema: e,
		*entries(n) {
			if (F(n)) for (let r of t) yield [
				r,
				n[r],
				e[r]
			];
		},
		validator(e) {
			return F(e) || `Expected an object, but received: ${I(e)}`;
		}
	});
}
function Y(e) {
	let t = e.map((e) => e.type).join(" | ");
	return new L({
		type: "union",
		schema: null,
		coercer(t, n) {
			return (e.find((e) => {
				let [n] = e.validate(t, { coerce: !0 });
				return !n;
			}) || An()).coercer(t, n);
		},
		validator(n, r) {
			let i = [];
			for (let t of e) {
				let [ ...e] = vn(n, t, r), [a] = e;
				if (a[0]) for (let [t] of e) t && i.push(t);
				else return [];
			}
			return [`Expected the value to satisfy a union of \`${t}\`, but received: ${I(n)}`, ...i];
		}
	});
}
function An() {
	return z("unknown", () => !0);
}
//#endregion
//#region ../model/dist/index.es.js
var jn = G({
	package: J(),
	version: J(),
	name: J(),
	exportName: K(J()),
	destructuring: K(U()),
	subName: K(J()),
	main: K(J()),
	cssPaths: K(H(J()))
}), Mn = H(jn), X = /* @__PURE__ */ function(e) {
	return e.SLOT = "SLOT", e.FUNCTION = "FUNCTION", e.EXPRESSION = "EXPRESSION", e.ACTION = "ACTION", e.EVENT = "EVENT", e;
}({}), Nn = /* @__PURE__ */ function(e) {
	return e.FUNC = "FUNC", e.COMP = "COMP", e;
}({}), Pn = Y([
	J(),
	On(),
	U(),
	G({
		type: W(X.SLOT),
		renderType: Tn([Nn.FUNC, Nn.COMP]),
		params: K(H(J())),
		value: B(() => Y([Z, H(Z)]))
	}),
	G({
		type: W(X.EXPRESSION),
		value: J()
	}),
	G({
		type: W(X.FUNCTION),
		value: J()
	}),
	G({
		type: W(X.ACTION),
		handler: V()
	}),
	z("normalObj", (e) => !Ut(e) || [
		X.SLOT,
		X.EXPRESSION,
		X.FUNCTION
	].includes(e?.type) ? !1 : (R(e, q(J(), Pn)), !0)),
	H(B(() => Pn))
]), Fn = G({
	type: W(X.EXPRESSION),
	value: J()
}), Z = G({
	id: K(J()),
	title: K(J()),
	componentName: J(),
	props: K(q(J(), Pn)),
	nodeName: K(J()),
	state: K(q(J(), V())),
	children: B(() => K(H(Y([J(), Z])))),
	eventListener: K(H(V())),
	configure: K(V()),
	css: K(V()),
	style: K(V()),
	classNames: K(H(V())),
	refId: K(J()),
	extra: K(q(V(), V())),
	condition: K(Y([U(), Fn])),
	loop: K(G({
		open: U(),
		data: Y([H(V()), Fn]),
		args: K(H(J())),
		forName: K(J()),
		forIndex: K(J()),
		key: K(V()),
		name: K(J())
	})),
	injectEnvList: K(H(V())),
	methods: K(H(V()))
}), In = Y([J(), G({
	label: J(),
	tip: K(J())
})]), Ln = G({
	type: W("shape"),
	value: H(G({
		name: J(),
		title: In,
		valueType: B(() => Bn)
	}))
}), Rn = G({
	type: W("enums"),
	value: H(J())
});
G({
	type: W("array"),
	value: B(() => Bn)
});
var zn = G({
	type: W("array"),
	value: B(() => H(Bn))
}), Bn = Y([
	Tn([
		"array",
		"boolean",
		"number",
		"object",
		"string"
	]),
	Tn([
		"component",
		"expression",
		"function"
	]),
	Ln,
	Rn,
	zn
]), Vn = Y([J(), G({
	componentName: J(),
	props: K(V()),
	initialValue: K(V()),
	component: K(V()),
	hiddenLabel: K(U())
})]), Hn = G({
	name: J(),
	title: In,
	valueType: Bn,
	description: K(J()),
	defaultValue: V(),
	setters: K(H(Vn)),
	readOnly: K(U()),
	condition: K(En())
});
Y([J(), En()]), Y([J(), G({
	event: J(),
	name: K(J()),
	describe: K(J()),
	params: K(H(G({
		name: J(),
		description: J(),
		example: J()
	}))),
	template: K(J())
})]);
var Un = G({
	id: K(J()),
	title: J(),
	snapshot: Y([J(), V()]),
	snapshotText: K(J()),
	description: K(J()),
	tags: K(H(J())),
	groupName: K(J()),
	category: K(J()),
	schema: Cn(wn(Z, ["id"]), G({ componentName: K(J()) }))
});
G({
	componentName: J(),
	title: J(),
	screenshot: K(J()),
	icon: K(J()),
	tags: K(H(J())),
	groupName: K(J()),
	category: K(J()),
	priority: K(On()),
	npm: K(jn),
	snippets: H(Un),
	props: H(Y([
		Hn,
		G({
			title: K(In),
			type: W("single"),
			content: Hn
		}),
		G({
			title: K(In),
			type: W("group"),
			content: H(Hn)
		})
	])),
	events: K(V()),
	methods: K(V()),
	fixedProps: K(V()),
	isContainer: K(Y([U(), G({
		placeholder: J(),
		width: J(),
		height: J()
	})])),
	disableEditorDragDom: K(V()),
	enableNodeSizeChange: K(Y([U(), En()])),
	isLayout: K(U()),
	rootSelector: K(J()),
	advanceCustom: K(V()),
	extra: K(q(V(), V()))
});
var Wn = /* @__PURE__ */ function(e) {
	return e.ROOT_CONTAINER = "RootContainer", e;
}({}), Gn = G({
	type: W(X.FUNCTION),
	value: J()
}), Kn = Cn(wn(Z, ["componentName"]), G({ componentName: W("RootContainer") }));
b();
var qn = () => Math.random().toString(32).slice(3, 9);
G({
	version: K(J()),
	name: K(J()),
	css: K(J()),
	lifecycle: K(V()),
	props: K(V()),
	methods: K(H(Gn)),
	componentsMeta: H(Cn(G({ componentName: J() }), jn)),
	thirdLibs: K(Mn),
	componentsTree: Kn,
	assets: K(H(V())),
	extra: K(V())
}), Wn.ROOT_CONTAINER;
//#endregion
//#region src/components/DropAnchor/util.ts
function Jn(e, t) {
	let { display: n, flexDirection: r } = t;
	if (n === "flex" && ["row", "row-reverse"].includes(r)) return !1;
	let { display: i } = e;
	return ![
		"inline",
		"inline-block",
		"float",
		"grid"
	].includes(i);
}
function Yn(e) {
	let { point: t, dom: n } = e, r, i = getComputedStyle(n), a = !0;
	n.parentElement && (a = Jn(i, getComputedStyle(n.parentElement)));
	let o = t, s = n.getBoundingClientRect(), c = s.width, l = s.height, u = s.x + Math.round(c / 2), d = s.y + Math.round(l / 2);
	return e.isContainer && o.y > s.y + 10 && o.y < s.y + s.height - 10 && o.x > s.x + 10 && o.x < s.x + s.width - 10 ? (r = "current", {
		pos: r,
		direction: "horizontal"
	}) : (r = a ? o.y > d ? "after" : "before" : o.x > u ? "after" : "before", {
		pos: r,
		direction: a ? "vertical" : "horizontal"
	});
}
var Q = {
	sizeBox: "_sizeBox_9mhaf_1",
	handle: "_handle_9mhaf_7",
	top: "_top_9mhaf_20",
	bottom: "_bottom_9mhaf_21",
	left: "_left_9mhaf_37",
	right: "_right_9mhaf_38",
	resizing: "_resizing_9mhaf_54",
	arrow: "_arrow_9mhaf_58"
}, Xn = 1, Zn = 48, Qn = [
	"top",
	"right",
	"bottom",
	"left"
], $n = (e) => {
	let t = e.getDom(), n = e._NODE_MODEL.material?.value.rootSelector;
	return n && t && (t = t.querySelector?.(n) || t), t && t.nodeType === 1 ? t : null;
}, er = (e) => {
	let t = $n(e)?.getBoundingClientRect();
	return t ? {
		left: t.left,
		top: t.top,
		width: t.width,
		height: t.height
	} : null;
}, tr = (e) => ({
	x: e.clientX,
	y: e.clientY
}), nr = (e, t) => {
	let { edge: n, startRect: r, startPointer: i } = e, a = t.x - i.x, o = t.y - i.y, s = Math.max(Xn, r.width + (n === "left" ? -a : n === "right" ? a : 0)), c = Math.max(Xn, r.height + (n === "top" ? -o : n === "bottom" ? o : 0));
	return {
		left: r.left + (n === "left" ? r.width - s : 0),
		top: r.top + (n === "top" ? r.height - c : 0),
		width: s,
		height: c
	};
}, rr = ({ instance: e, getCurrentInstance: t, node: i, active: c, onChange: u }) => {
	let [d, f] = s(null), [p, m] = s(!1), h = o(e), g = o(t), _ = o(i), v = o(u), y = o(null), b = o(null);
	h.current = e, g.current = t, _.current = i, v.current = u, r(() => () => {
		b.current && clearTimeout(b.current);
	}, []);
	let x = n(() => {
		y.current || f(er(g.current?.() || h.current));
	}, []);
	a(() => {
		if (!c) {
			y.current = null, b.current &&= (clearTimeout(b.current), null), m(!1), f(null);
			return;
		}
		x();
		let e = requestAnimationFrame(() => x());
		return () => cancelAnimationFrame(e);
	}, [c, x]), r(() => {
		if (!c) return;
		let t = $n(g.current?.() || e), n = t?.ownerDocument.defaultView, r = Array.from(new Set([window, n].filter(Boolean))), i = typeof ResizeObserver > "u" || !t ? null : new ResizeObserver(x), a = n?.MutationObserver ?? (typeof MutationObserver > "u" ? null : MutationObserver), o = a && t?.ownerDocument.body ? new a(() => x()) : null;
		return i && t && i.observe(t), o && t && o.observe(t.ownerDocument.body, {
			attributes: !0,
			attributeFilter: ["class", "style"],
			childList: !0,
			subtree: !0
		}), r.forEach((e) => {
			e.addEventListener("resize", x), e.addEventListener("scroll", x, !0);
		}), () => {
			i?.disconnect(), o?.disconnect(), r.forEach((e) => {
				e.removeEventListener("resize", x), e.removeEventListener("scroll", x, !0);
			});
		};
	}, [
		c,
		e,
		x
	]), r(() => {
		let e = (e) => {
			let t = y.current;
			if (!t || t.pointerId !== e.pointerId) return;
			let n = tr(e);
			if (n.x === t.lastPointer.x && n.y === t.lastPointer.y) return;
			let r = nr(t, n);
			t.lastPointer = n, f(r), v.current(_.current, {
				from: t.from,
				current: e,
				pointer: n,
				extraData: {
					edge: t.edge,
					width: r.width,
					height: r.height,
					originalWidth: t.startRect.width,
					originalHeight: t.startRect.height,
					viewportWidth: $n(g.current?.() || h.current)?.ownerDocument.defaultView?.innerWidth ?? window.innerWidth
				}
			});
		}, t = (t) => {
			e(t), y.current?.pointerId === t.pointerId && (y.current = null, b.current && clearTimeout(b.current), b.current = setTimeout(() => {
				b.current = null, m(!1);
			}, Zn), requestAnimationFrame(() => x()));
		};
		return window.addEventListener("pointermove", e), window.addEventListener("pointerup", t), window.addEventListener("pointercancel", t), () => {
			window.removeEventListener("pointermove", e), window.removeEventListener("pointerup", t), window.removeEventListener("pointercancel", t);
		};
	}, [x]);
	let S = (e, t) => {
		if (t.button !== 0 || !d) return;
		t.preventDefault(), t.stopPropagation(), b.current &&= (clearTimeout(b.current), null);
		let n = tr(t.nativeEvent);
		y.current = {
			edge: e,
			pointerId: t.pointerId,
			from: t.nativeEvent,
			startRect: d,
			startPointer: n,
			lastPointer: n
		}, m(!0), t.currentTarget.setPointerCapture(t.pointerId);
	};
	return !c || !d ? null : /* @__PURE__ */ l("div", {
		className: Q.sizeBox,
		"data-chameleon-dnd-ignore": "true",
		style: {
			left: d.left,
			top: d.top,
			width: d.width,
			height: d.height
		},
		onPointerDown: (e) => e.stopPropagation(),
		children: Qn.map((e) => /* @__PURE__ */ l("div", {
			className: `${Q.handle} ${Q[e]} ${p ? Q.resizing : ""}`,
			"data-chameleon-dnd-ignore": "true",
			role: "button",
			"aria-label": `Resize from ${e}`,
			onPointerDown: (t) => S(e, t),
			children: /* @__PURE__ */ l("span", {
				className: Q.arrow,
				"aria-hidden": "true"
			})
		}, e))
	});
}, ir = /* @__PURE__ */ new Set(["inline", "none"]), ar = (e) => {
	if (typeof e != "string") return !1;
	let t = e.replace(/\s*!important\s*$/i, "").trim().toLowerCase();
	return ir.has(t);
}, or = (e) => typeof e == "string" && /(?:^|[;{])\s*display\s*:\s*(?:inline|none)\s*(?:!important\s*)?(?=[;}\s]|$)/i.test(e), sr = (e) => {
	let t = e?._NODE_MODEL;
	if (!t) return !1;
	let n = t.material?.value.enableNodeSizeChange;
	return typeof n == "function" ? n(t) : n === !0;
}, cr = (e) => {
	let t = e?._NODE_MODEL.value.style;
	return t ? Array.isArray(t) ? t.some(({ property: e }) => e === "width" || e === "height") : t.width !== void 0 || t.height !== void 0 : !1;
}, lr = (e) => {
	let t = e?._NODE_MODEL.value, n = t?.style;
	return (Array.isArray(n) ? n.some(({ property: e, value: t }) => e === "display" && ar(t)) : ar(n?.display)) ? !0 : t?.css?.value.some(({ text: e, media: t }) => [e, ...(t || []).map(({ text: e }) => e)].some(or)) ?? !1;
}, ur = (e, t = !1) => !cr(e) && !lr(e) && (t || sr(e)), dr = (e) => {
	let t = e.node.isContainer(), n = typeof t == "object" ? t : {}, { placeholder: r = "Drag the component to place it", width: i = n.width || "100%", height: a = n.height || "100%", style: o = n.style } = e;
	return /* @__PURE__ */ l("span", {
		style: {
			margin: 0,
			padding: "0 16px",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			backgroundColor: "rgba(44, 115, 253, 0.04)",
			border: "1px dashed rgba(44, 115, 253, 0.42)",
			borderRadius: "3px",
			fontSize: "13px",
			fontWeight: 500,
			letterSpacing: "0.01em",
			color: "rgba(44, 83, 145, 0.72)",
			cursor: "default",
			minHeight: "50px",
			width: i,
			height: a,
			boxSizing: "border-box",
			transition: "background-color 0.15s ease, border-color 0.15s ease",
			...o
		},
		children: r
	});
}, $ = {
	layoutRoot: "_layoutRoot_thkv6_1",
	canvasToolbar: "_canvasToolbar_thkv6_9",
	layoutContainer: "_layoutContainer_thkv6_25",
	canvasPanReady: "_canvasPanReady_thkv6_40",
	canvasPanning: "_canvasPanning_thkv6_43",
	layoutContainerDragging: "_layoutContainerDragging_thkv6_48",
	canvasZoomed: "_canvasZoomed_thkv6_52",
	elementHighlightBox: "_elementHighlightBox_thkv6_61",
	iframeBox: "_iframeBox_thkv6_68",
	canvasViewport: "_canvasViewport_thkv6_72"
}, fr = /* @__PURE__ */ function(e) {
	return e.EDIT = "EDIT", e.PREVIEW = "PREVIEW", e;
}({}), pr = { backgroundColor: "rgba(0,0,0,0.2)" }, mr = class extends e.Component {
	designRenderRef;
	iframeContainer;
	eventExposeHandler;
	state;
	highlightCanvasRef;
	dnd;
	highlightHoverCanvasRef;
	highlightDropAnchorCanvasRef;
	readyCbList = [];
	assets = [];
	dragStartNode = null;
	disposeDndMouseMoveListener = null;
	canvasPanEventDisposeHandlers = [];
	canvasPanStart = null;
	canvasPanOverlay = null;
	isSpacePressed = !1;
	isZoomModifierPressed = !1;
	realTimeSelectNodeInstanceTimer = 0;
	iframeDomId;
	canvasWorkspaceRef;
	isCancelDrag;
	mode = "EDIT";
	constructor(t) {
		super(t), this.iframeDomId = qn(), this.designRenderRef = e.createRef(), this.iframeContainer = new d(), this.eventExposeHandler = [], this.isCancelDrag = !1, this.mode = t.mode ?? "EDIT", this.state = {
			isDragging: !1,
			ready: !1,
			mousePointer: null,
			currentSelectInstance: null,
			currentSelectId: "",
			selectComponentInstances: [],
			selectLockStyle: {},
			hoverComponentInstances: [],
			dropComponentInstances: [],
			dropPosInfos: [],
			dropEvent: null,
			dropInfo: null,
			canDrop: !0,
			canvasScale: 1,
			canvasOffsetX: 0,
			canSelectNode: !0,
			pointerEventsForHightLightBox: "none"
		}, this.highlightCanvasRef = e.createRef(), this.highlightHoverCanvasRef = e.createRef(), this.highlightDropAnchorCanvasRef = e.createRef(), this.canvasWorkspaceRef = e.createRef();
		let n = new sn({
			doc: document,
			win: window
		});
		this.dnd = n;
	}
	componentDidMount() {
		this.init();
	}
	disposeRealTimeUpdate = () => {
		this.realTimeSelectNodeInstanceTimer &&= (clearInterval(this.realTimeSelectNodeInstanceTimer), 0);
	};
	reload() {
		return this.init();
	}
	setMode(e) {
		this.mode = e, this.mode === "PREVIEW" && this.clearSelectNode();
	}
	setCanvasScale(e) {
		if (!Number.isFinite(e) || e <= 0) return;
		let t = this.canvasWorkspaceRef.current, n = this.iframeContainer.containerDom, r = 0;
		if (t && n) {
			let i = window.getComputedStyle(t), a = (t.clientWidth - Number.parseFloat(i.paddingLeft) - Number.parseFloat(i.paddingRight) - n.offsetWidth * e) / 2;
			r = Math.max(0, a);
		}
		this.setState({
			canvasScale: e,
			canvasOffsetX: r
		}, () => {
			let t = this.canvasWorkspaceRef.current;
			t && requestAnimationFrame(() => {
				let n = Math.max(0, t.scrollWidth - t.clientWidth);
				t.scrollLeft = e > 1 ? n / 2 : 0, t.scrollTop = 0;
				let r = document.getElementById(this.iframeDomId);
				if (r) {
					let e = t.getBoundingClientRect(), i = r.getBoundingClientRect(), a = window.getComputedStyle(t), o = e.left + Number.parseFloat(a.paddingLeft), s = e.right - Number.parseFloat(a.paddingRight);
					i.left < o ? t.scrollLeft = Math.max(0, t.scrollLeft - (o - i.left)) : i.right > s && (t.scrollLeft = Math.min(n, t.scrollLeft + (i.right - s)));
				}
			}), this.highlightCanvasRef.current?.update(), this.highlightHoverCanvasRef.current?.update(), this.highlightDropAnchorCanvasRef.current?.update(), this.props.onCanvasScaleChange?.(e);
		});
	}
	fitCanvasToViewport() {
		let e = this.canvasWorkspaceRef.current, t = this.iframeContainer.containerDom;
		if (!e || !t) return;
		let n = window.getComputedStyle(e), r = e.clientWidth - Number.parseFloat(n.paddingLeft) - Number.parseFloat(n.paddingRight), i = t.offsetWidth;
		if (r <= 0 || i <= 0) return;
		let a = Math.min(1, Math.max(.25, r / i));
		this.setCanvasScale(Number(a.toFixed(2)));
	}
	init() {
		this.disposeDndMouseMoveListener?.(), this.disposeDndMouseMoveListener = null, this.clearCanvasPanEvents(), this.dnd.clearSensors(), this.props.onPageRuntimeReady?.(null), this.iframeContainer.destroy(), this.iframeContainer = new d(), window.___CHAMELEON_DESIGNER_RENDER___ = this.designRenderRef;
		let e = this.iframeContainer;
		e.load(document.getElementById(this.iframeDomId)), e.onLoadFailed((e) => {
			console.error("iframe canvas load failed", e);
		}), e.ready(async () => {
			let t = e.getWindow();
			if (t && this.props.onPageRuntimeReady?.(t), this.props.beforeInitRender) await this.props.beforeInitRender({
				pageModel: this.props.pageModel,
				page: this.props.page,
				assets: this.props.assets || [],
				iframe: e
			});
			else throw Error("Must pass beforeInitRender methods");
			let n = async () => {
				let t = e.getWindow();
				t.__C_ENGINE_DESIGNER_PLUGIN_CTX__ = this.props.pluginCtx;
			};
			if (await n(), this.registerCanvasPanEvents(), this.props.customRender) this.props.customRender({
				pageModel: this.props.pageModel,
				page: this.props.page,
				assets: this.props.assets || [],
				iframe: e,
				renderJSUrl: this.props.renderJSUrl,
				beforeInitRender: n,
				dropPlaceholder: this.props.dropPlaceholder || dr,
				ready: (e) => {
					this.designRenderRef.current = e, this.registerDragAndDropEvent(), this.registerSelectEvent(), this.registerHoverEvent(), this.registerEventLimit(), this.readyOk();
				}
			});
			else throw Error("Must pass customRender methods");
		});
	}
	clearCanvasPanEvents() {
		this.canvasPanEventDisposeHandlers.forEach((e) => e()), this.canvasPanEventDisposeHandlers = [], this.removeCanvasPanOverlay(), this.canvasPanStart = null, this.isSpacePressed = !1, this.isZoomModifierPressed = !1;
	}
	removeCanvasPanOverlay() {
		this.canvasPanOverlay?.remove(), this.canvasPanOverlay = null;
	}
	registerCanvasPanEvents() {
		let e = this.canvasWorkspaceRef.current, t = this.iframeContainer.getDocument();
		if (!e || !t) return;
		let n = (e) => {
			let t = e;
			return t?.isContentEditable || [
				"INPUT",
				"TEXTAREA",
				"SELECT"
			].includes(t?.tagName || "");
		}, r = (t) => {
			e.classList.toggle($.canvasPanning, t), e.classList.toggle($.canvasPanReady, this.isSpacePressed && !t), this.canvasPanOverlay && (this.canvasPanOverlay.style.cursor = this.isSpacePressed ? t ? "grabbing" : "grab" : "default");
		}, i = () => {
			this.canvasPanStart && (this.canvasPanStart = null, r(!1));
		}, a = (e) => {
			if (e.key === "Control" || e.key === "Meta") {
				this.isZoomModifierPressed || f(), this.isZoomModifierPressed = !0;
				return;
			}
			e.code !== "Space" || n(e.target) || (this.isSpacePressed || (this.isCancelDrag = !0, this.dnd.cancelDrag(), f()), this.isSpacePressed = !0, e.preventDefault(), r(!1));
		}, o = (e) => {
			if (e.key === "Control" || e.key === "Meta") {
				this.isZoomModifierPressed = !1, this.isSpacePressed || this.removeCanvasPanOverlay();
				return;
			}
			e.code === "Space" && (this.isSpacePressed = !1, i(), this.isZoomModifierPressed || this.removeCanvasPanOverlay(), this.resetDrag(), this.dnd.resetDrag(), this.isCancelDrag = !1, r(!1));
		}, s = (t) => {
			!this.isSpacePressed || t.button !== 0 || (t.preventDefault(), t.stopImmediatePropagation(), this.canvasPanStart = {
				clientX: t.clientX,
				clientY: t.clientY,
				scrollLeft: e.scrollLeft,
				scrollTop: e.scrollTop
			}, r(!0));
		}, c = (t) => {
			this.canvasPanStart && (t.preventDefault(), t.stopImmediatePropagation(), e.scrollLeft = this.canvasPanStart.scrollLeft - (t.clientX - this.canvasPanStart.clientX), e.scrollTop = this.canvasPanStart.scrollTop - (t.clientY - this.canvasPanStart.clientY));
		}, l = (e) => {
			this.canvasPanStart && (e.preventDefault(), e.stopImmediatePropagation(), i());
		}, u = (e) => {
			if (!e.ctrlKey && !e.metaKey) return;
			e.preventDefault(), e.stopPropagation();
			let t = e.deltaY > 0 ? -.1 : .1, n = Math.min(2, Math.max(.25, this.state.canvasScale + t));
			this.setCanvasScale(Number(n.toFixed(2)));
		}, d = (e) => {
			e.preventDefault(), this.setCanvasScale(1);
		}, f = () => {
			let e = this.iframeContainer.containerDom;
			if (this.canvasPanOverlay || !e) return;
			let t = document.createElement("div");
			t.style.cssText = `position: absolute; inset: 0; z-index: 3; background: transparent; cursor: ${this.isSpacePressed ? "grab" : "default"}; user-select: none;`, t.addEventListener("mousedown", s, !0), t.addEventListener("mousemove", c, !0), t.addEventListener("mouseup", l, !0), e.appendChild(t), this.canvasPanOverlay = t;
		}, p = (e, t, n, r = !0) => {
			e.addEventListener(t, n, r), this.canvasPanEventDisposeHandlers.push(() => e.removeEventListener(t, n, r));
		};
		p(document, "keydown", a), p(document, "keyup", o), p(t, "keydown", a), p(t, "keyup", o), p(document, "wheel", u, {
			capture: !0,
			passive: !1
		}), p(t, "wheel", u, {
			capture: !0,
			passive: !1
		}), p(t, "dblclick", d), p(e, "mousedown", s), p(e, "mousemove", c), p(e, "mouseup", l);
	}
	banSelectNode() {
		this.setState({ canSelectNode: !1 });
	}
	recoverSelectNode() {
		this.setState({ canSelectNode: !0 });
	}
	getPageModel() {
		return this.designRenderRef?.current?.getPageModel();
	}
	readyOk() {
		this.setState({ ready: !0 });
		let e = this.readyCbList;
		for (this.readyCbList = []; e.length;) e.shift()?.(this);
	}
	registerSelectEvent() {
		let e = this.iframeContainer.getDocument(), t = this.iframeContainer.getWindow();
		!e || !t || this.eventExposeHandler.push(f(e.body, "click", async (e) => {
			if (this.mode === "PREVIEW" || !this.designRenderRef.current) return;
			let t = this.designRenderRef.current.getInstanceByDom(e.target);
			if (!t) return;
			let n = this.designRenderRef.current.getInstancesById(t._NODE_ID || "");
			t._NODE_MODEL.nodeType === "NODE" && await this.props.onSelectNode?.(t._NODE_MODEL, e) !== !1 && this.state.canSelectNode && this.setState({
				currentSelectId: t._NODE_ID,
				currentSelectInstance: t,
				selectComponentInstances: [...n],
				hoverComponentInstances: []
			});
		}, !0));
	}
	registerHoverEvent() {
		let e = this.iframeContainer.getDocument();
		e && (this.eventExposeHandler.push(f(e.body, "mouseover", (e) => {
			if (this.mode === "PREVIEW" || !e.target) return;
			let t = e.target, n = this.designRenderRef.current?.getInstanceByDom(t);
			if (this.props.onHoverNode?.(n?._NODE_MODEL || null, this.dragStartNode, e), n?._NODE_ID === this.state.selectComponentInstances[0]?._NODE_ID) {
				this.setState({ hoverComponentInstances: [] });
				return;
			}
			let r = this.designRenderRef.current?.getInstancesById(n?._NODE_ID || "") || [];
			this.setState({ hoverComponentInstances: r });
		}, !0)), this.eventExposeHandler.push(f(e.body, "mouseleave", () => {
			this.setState({ hoverComponentInstances: [] });
		}, !0)));
	}
	registerEventLimit() {
		let e = this.iframeContainer.getDocument(), t = this.iframeContainer.getWindow();
		e?.addEventListener("contextmenu", function(e) {
			e.preventDefault();
		}), !(!e || !t) && ["mousedown", "mouseup"].forEach((t) => {
			this.eventExposeHandler.push(f(e.body, t, async (e) => {
				if (this.mode === "PREVIEW") return;
				let t = this.designRenderRef.current?.getInstanceByDom(e.target)?._NODE_MODEL;
				if (t) {
					let n = t.material?.value.disableEditorDragDom;
					if (n === !0) {
						this.cancelDrag();
						return;
					}
					if (typeof n == "object") {
						let t = e.target, r = t?.classList || [], i = t?.id, a = on(r, n.class || []).length, o = on([i], n.id || []).length;
						if (a || o) {
							this.cancelDrag();
							return;
						}
					}
				}
			}, !0));
		});
	}
	cancelDrag(e) {
		this.isCancelDrag = !0, this.resetDrag(), this.dnd.cancelDrag();
	}
	registerDragAndDropEvent() {
		let e = this.dnd, t = new S({
			name: "layout",
			container: this.iframeContainer.getDocument(),
			offsetDom: document.getElementById(this.iframeDomId),
			pointerScale: () => this.state.canvasScale,
			mainDocument: document
		});
		t.setCanDrag(async (e) => {
			if (this.mode === "PREVIEW") return;
			let n = this.designRenderRef.current?.getInstanceByDom(e.event.target);
			if (!n) return null;
			let r = this.state.currentSelectInstance?._NODE_MODEL?.contains(n?._NODE_ID || ""), i = n?._NODE_MODEL, a = i;
			r && this.state.currentSelectInstance && (i = this.state.currentSelectInstance?._NODE_MODEL);
			let o = {
				...e,
				from: e.event,
				fromPointer: e.pointer,
				fromSensor: t,
				extraData: {
					...e.extraData || {},
					originDragNode: i,
					dragNode: a,
					dragNodeUID: n?._UNIQUE_ID
				}
			};
			if (this.props.nodeCanDrag) {
				let e = await this.props.nodeCanDrag(o);
				if (e === !1) return !1;
				typeof e == "object" && (o.extraData = {
					...o.extraData,
					dragNode: e.dragNode ?? o.extraData.dragNode
				});
			}
			return o;
		}), t.setCanDrop(async (e) => {
			let n = this.designRenderRef.current?.getInstanceByDom(e.event.target);
			if (!n) {
				this.setState({ dropComponentInstances: [] });
				return;
			}
			if (this.state.currentSelectInstance?._NODE_MODEL?.contains(n?._NODE_ID || "")) return;
			let r = n._NODE_MODEL, i = r.isContainer() || r.value?.componentName === Wn.ROOT_CONTAINER, a = e.event, o = n.getDom(), s = Yn({
				point: {
					x: a.clientX,
					y: a.clientY
				},
				dom: o,
				isContainer: !!i
			}), c = {
				...e,
				from: e.event,
				fromPointer: e.pointer,
				fromSensor: t,
				extraData: {
					...e.extraData || {},
					dropPosInfo: s,
					dropNode: n?._NODE_MODEL,
					dropNodeUID: n?._UNIQUE_ID
				}
			};
			if (this.props.nodeCanDrop) {
				let e = await this.props.nodeCanDrop?.(c);
				if (e === !1) return !1;
				typeof e == "object" && (c.extraData = {
					...c.extraData,
					...e
				});
			}
			return c;
		}), e.registerSensor(t);
		let { onSelectNode: n } = this.props;
		t.emitter.on("dragStart", async (e) => {
			if (this.mode === "PREVIEW" || this.isCancelDrag) return;
			this.setState({ isDragging: !0 });
			let { currentSelectInstance: t } = this.state, r = e.extraData, i = r.dragNode, a = (this.designRenderRef.current?.getInstancesById(i?.id || "") || []).shift();
			this.dragStartNode = i || null;
			let o = this.designRenderRef.current?.getDomsById(t?._NODE_ID || ""), s = this.designRenderRef.current?.getDomsById(i?.id || "");
			if (r?.dropType === "NEW_ADD") this.setState({
				currentSelectId: "",
				currentSelectInstance: null,
				selectComponentInstances: [],
				hoverComponentInstances: []
			}), n?.(null, e.current);
			else if (o?.length && s?.length) {
				if (!a) return;
				if (o[0].contains(s[0])) {
					if (this.dragStartNode = t?._NODE_MODEL || null, this.props.onNodeDragStart && (e.extraData.dragNode = this.dragStartNode, e.extraData.dragNodeUID = t?._UNIQUE_ID, await this.props.onNodeDragStart(e) === !1)) {
						this.cancelDrag(e);
						return;
					}
					this.setState({ hoverComponentInstances: [] });
				} else {
					if (this.props.onNodeDragStart && await this.props.onNodeDragStart(e) === !1) {
						this.cancelDrag(e);
						return;
					}
					this.setState({
						currentSelectId: a._NODE_ID,
						currentSelectInstance: a,
						selectComponentInstances: this.designRenderRef.current?.getInstancesById(a?._NODE_ID || "") || [],
						hoverComponentInstances: []
					}), n?.(a?._NODE_MODEL || null, e.current);
				}
			} else if (o?.length) this.setState({ hoverComponentInstances: [] });
			else {
				if (!a) return;
				if (this.props.onNodeDragStart && await this.props.onNodeDragStart(e) === !1) {
					this.cancelDrag(e);
					return;
				}
				this.setState({
					currentSelectId: a._NODE_ID,
					currentSelectInstance: a,
					selectComponentInstances: this.designRenderRef.current?.getInstancesById(a?._NODE_ID || "") || [],
					hoverComponentInstances: []
				}), n?.(a?._NODE_MODEL || null, e.current);
			}
		}), t.emitter.on("dragging", async (e) => {
			if (!this.designRenderRef.current || this.isCancelDrag || this.mode === "PREVIEW") return;
			let t = e.extraData;
			if (await this.props.onNodeDragging?.(e) === !1) {
				this.cancelDrag(e);
				return;
			}
			let n = (this.designRenderRef.current.getInstancesById(t.dropNode?.id || "", t.dropNodeUID) || []).shift();
			if (!n) {
				this.setState({
					dropComponentInstances: [],
					dropPosInfos: [],
					dropEvent: null
				});
				return;
			}
			this.setState({
				dropComponentInstances: [n],
				dropPosInfos: [t.dropPosInfo],
				dropEvent: e
			});
		}), t.emitter.on("dragEnd", (e) => {
			this.resetDrag(), this.isCancelDrag = !1, this.props.onNodeDraEnd?.(e);
		}), t.emitter.on("drop", async (e) => {
			if (!this.designRenderRef.current || this.isCancelDrag) return;
			let { dragNode: t } = e.extraData;
			if (t && await this.props.onNodeNewAdd?.(e) === !1) {
				this.resetDrag();
				return;
			}
			this.props.onNodeDrop?.(e);
		});
		let r = (e) => {
			if (this.mode === "PREVIEW") {
				this.setState({
					mousePointer: null,
					selectLockStyle: {}
				});
				return;
			}
			this.state.isDragging ? this.setState({
				mousePointer: e.pointer,
				selectLockStyle: pr
			}) : this.setState({
				mousePointer: null,
				selectLockStyle: {}
			});
		};
		t.emitter.on("mouseMove", r), this.dnd.emitter.on("mouseMove", r), this.disposeDndMouseMoveListener = () => {
			this.dnd.emitter.off("mouseMove", r);
		};
	}
	selectNode(e) {
		let t = this.designRenderRef.current?.getInstancesById(e) || [];
		if (t = t.filter((e) => e?._STATUS !== "DESTROY"), !t.length) {
			this.setState({
				currentSelectId: "",
				currentSelectInstance: null,
				selectComponentInstances: [],
				hoverComponentInstances: []
			});
			return;
		}
		let n = t[0], r = n.getDom();
		r && r.scrollIntoView?.({ block: "nearest" }), this.setState({
			currentSelectId: n._NODE_ID,
			currentSelectInstance: n,
			selectComponentInstances: [...t].filter((e) => {
				let t, n = this.designRenderRef.current?.renderRef?.current?.dynamicComponentInstanceMap.get(e._NODE_ID);
				return n && (t = n._CONDITION), t !== !1;
			}),
			hoverComponentInstances: []
		}), this.props.onSelectNode?.(n?._NODE_MODEL, null);
	}
	clearSelectNode() {
		this.setState({
			currentSelectId: "",
			currentSelectInstance: null,
			selectComponentInstances: []
		}), this.props.onSelectNode?.(null, null);
	}
	resetDrag = () => {
		this.dragStartNode = null, this.setState({
			isDragging: !1,
			mousePointer: null,
			dropEvent: null,
			dropComponentInstances: [],
			selectLockStyle: {}
		});
	};
	componentWillUnmount() {
		this.disposeDndMouseMoveListener?.(), this.clearCanvasPanEvents(), this.eventExposeHandler.forEach((e) => e()), this.props.onPageRuntimeReady?.(null), this.iframeContainer.iframe?.parentNode?.removeChild(this.iframeContainer.iframe), this.disposeRealTimeUpdate();
	}
	async ready(e) {
		return this.state.ready ? (e?.(this), this) : new Promise((t) => {
			this.readyCbList.push((n) => {
				e?.(n), t(n);
			});
		});
	}
	selectRectViewItemRender = (e) => {
		if (this.mode === "PREVIEW") return /* @__PURE__ */ l(c, {});
		let { selectRectViewRender: t } = this.props, n = t;
		return n ? /* @__PURE__ */ l(n, {
			instance: e.instance,
			index: e.index,
			isLock: !1
		}) : /* @__PURE__ */ l(c, {});
	};
	hoverRectViewItemRender = (e) => {
		if (this.mode === "PREVIEW") return /* @__PURE__ */ l(c, {});
		let { hoverRectViewRender: t } = this.props, n = t;
		return n ? /* @__PURE__ */ l(n, {
			instance: e.instance,
			index: e.index,
			isLock: !1
		}) : /* @__PURE__ */ l(c, {});
	};
	dropViewItemRender = (e) => {
		let { dropViewRender: t } = this.props, n = t;
		return n ? /* @__PURE__ */ l(n, {
			...e,
			instance: e.instance,
			index: 0,
			isLock: !1
		}) : /* @__PURE__ */ l(c, {});
	};
	render() {
		let { selectComponentInstances: e, hoverComponentInstances: t, dropComponentInstances: n, dropPosInfos: r, dropEvent: i, selectLockStyle: a, isDragging: o, mousePointer: s, canvasScale: d, canvasOffsetX: f } = this.state, { iframeDomId: p } = this, m = this.state.currentSelectInstance, h = ur(m, this.props.forceNodeSizeChange), g = this.props.nodeSizeChangeAlwaysVisible ?? !0, { selectToolbarView: _, hoverToolBarView: v, selectBoxStyle: b = {}, hoverBoxStyle: x = {}, ghostView: S = /* @__PURE__ */ l(c, { children: "Ghost" }), selectRectViewRender: ee, hoverRectViewRender: C, dropViewRender: w } = this.props, T;
		ee && (T = this.selectRectViewItemRender);
		let E;
		C && (E = this.hoverRectViewItemRender);
		let D;
		w && (D = this.dropViewItemRender);
		let te = d < 1 ? `${100 / d}%` : "100%", O = [
			$.layoutContainer,
			d > 1 ? $.canvasZoomed : "",
			o ? $.layoutContainerDragging : ""
		].filter(Boolean).join(" ");
		return /* @__PURE__ */ u("div", {
			className: $.layoutRoot,
			children: [this.props.canvasToolbarView && /* @__PURE__ */ l("div", {
				className: $.canvasToolbar,
				children: this.props.canvasToolbarView
			}), /* @__PURE__ */ u("div", {
				ref: this.canvasWorkspaceRef,
				className: O,
				children: [/* @__PURE__ */ u("div", {
					className: $.canvasViewport,
					id: p,
					style: {
						height: te,
						transform: `translateX(${f}px) scale(${d})`,
						transformOrigin: "left top"
					},
					children: [
						/* @__PURE__ */ l(y, {
							ref: this.highlightHoverCanvasRef,
							instances: t,
							style: {
								pointerEvents: "none",
								position: "absolute",
								left: 0,
								top: 0,
								outline: "1px dashed rgba(0,0,255, .8)",
								whiteSpace: "nowrap",
								...x
							},
							toolbarView: v,
							itemRender: E
						}, "highlightHoverCanvasRef"),
						/* @__PURE__ */ l(y, {
							ref: this.highlightCanvasRef,
							instances: e,
							style: {
								...b,
								...a
							},
							toolbarView: _,
							itemRender: T
						}),
						m && h && g && this.props.onNodeSizeChange && /* @__PURE__ */ l(rr, {
							instance: m,
							getCurrentInstance: () => {
								let e = this.designRenderRef.current?.getInstancesById(m._NODE_ID) || [];
								return e.find((e) => e._UNIQUE_ID === m._UNIQUE_ID) || e[0] || m;
							},
							node: m._NODE_MODEL,
							active: !0,
							onChange: this.props.onNodeSizeChange
						}),
						/* @__PURE__ */ l(fn, {
							ref: this.highlightDropAnchorCanvasRef,
							instances: n,
							mouseEvent: i,
							dropInfos: r,
							customDropViewRender: D
						})
					]
				}), o && s && /* @__PURE__ */ l("div", {
					style: {
						position: "fixed",
						left: s.x - 5 + "px",
						top: s.y - 8 + "px",
						cursor: "move",
						pointerEvents: "none",
						zIndex: 999
					},
					children: S
				})]
			})]
		});
	}
};
//#endregion
export { x as DEmitter, dr as DefaultDropPlaceholder, sn as DragAndDrop, d as IFrameContainer, mr as Layout, fr as LayoutMode, S as Sensor, f as addEventListenerReturnCancel, m as animationFrame, p as isDOM };

//# sourceMappingURL=index.es.js.map